//export const SERVER_URL = "https://prueba.hotelnacional.tur.cu/graphql/";
//export const SERVER_URL = "https://193f-2a0d-5600-24-6-00-11.ngrok-free.app/graphql/";
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;